module.exports = __webpack_public_path__ + "static/media/roots_for_life_TEMP_logo_long.ffae1d20.png";